module.exports = __webpack_public_path__ + "static/media/restore.2cbbefcc.svg";